export const isVistaApplication = () => {
  return window.location.hostname.includes("vista");
};

// return value true / false
export const getFlagValueFromAttachConfig = (config) => {
  // array of object's
  if (config && config.length) {
    let foundConfig =
      config.find(
        (item) => item?.name === "neo_banking_vista_dashboard_config"
      ) || {}; // if undefined returned {}
    return (
      (Object.keys(foundConfig).length &&
        foundConfig?.config?.neobank_onedashboard_config
          ?.nb_dashboard_enabled) ||
      false
    );
  }
  return false;
};

export const getFeatureSideMenuSections = (sections) => {
  const featureMenus = sections.map((menuItem) => {
    if (menuItem.id === "neobanking") {
      const foundItem = menuItem.items.find((i) => i.text == "Vista");
      if (foundItem) {
        foundItem.text = "Go to Vista";
        foundItem.extras.isNew = true;
      }
              /* Commenting because Payout will be shown irrespective of the nbeligible flag */

      // const found = menuItem.list.findIndex((i) => i.title === "Payouts");

      // if (found === -1) {
      //   menuItem.list.push({
      //     active: false,
      //     isRestricted: () => false,
      //     icon: "payout",
      //     title: "Payouts",
      //     path: "/business/vista/payouts",
      //     classProp: "new-mer-tour-step1 mig-mer-tour-step1",
      //   });
      // }
    }
    return menuItem;
  });

  return featureMenus;
};
